"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserResponseDto = instanceOfUserResponseDto;
exports.UserResponseDtoFromJSON = UserResponseDtoFromJSON;
exports.UserResponseDtoFromJSONTyped = UserResponseDtoFromJSONTyped;
exports.UserResponseDtoToJSON = UserResponseDtoToJSON;
exports.UserResponseDtoToJSONTyped = UserResponseDtoToJSONTyped;
/**
 * Check if a given object implements the UserResponseDto interface.
 */
function instanceOfUserResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('pendingEmail' in value) || value['pendingEmail'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('isEmailVerified' in value) || value['isEmailVerified'] === undefined)
        return false;
    if (!('emailVerificationExpiresAt' in value) || value['emailVerificationExpiresAt'] === undefined)
        return false;
    if (!('mfaEnabled' in value) || value['mfaEnabled'] === undefined)
        return false;
    if (!('profilePhotoId' in value) || value['profilePhotoId'] === undefined)
        return false;
    if (!('profilePhotoUrl' in value) || value['profilePhotoUrl'] === undefined)
        return false;
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function UserResponseDtoFromJSON(json) {
    return UserResponseDtoFromJSONTyped(json, false);
}
function UserResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'pendingEmail': json['pendingEmail'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phone': json['phone'],
        'isActive': json['isActive'],
        'isEmailVerified': json['isEmailVerified'],
        'emailVerificationExpiresAt': (json['emailVerificationExpiresAt'] == null ? null : new Date(json['emailVerificationExpiresAt'])),
        'mfaEnabled': json['mfaEnabled'],
        'profilePhotoId': json['profilePhotoId'],
        'profilePhotoUrl': json['profilePhotoUrl'],
        'roles': json['roles'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function UserResponseDtoToJSON(json) {
    return UserResponseDtoToJSONTyped(json, false);
}
function UserResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'pendingEmail': value['pendingEmail'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
        'isActive': value['isActive'],
        'isEmailVerified': value['isEmailVerified'],
        'emailVerificationExpiresAt': value['emailVerificationExpiresAt'] == null ? value['emailVerificationExpiresAt'] : value['emailVerificationExpiresAt'].toISOString(),
        'mfaEnabled': value['mfaEnabled'],
        'profilePhotoId': value['profilePhotoId'],
        'profilePhotoUrl': value['profilePhotoUrl'],
        'roles': value['roles'],
        'createdAt': value['createdAt'].toISOString(),
    };
}
